import React from 'react'
import R from 'ramda'
import PropTypes from 'prop-types'
import XeroInvoice from '_views/xero/invoice'

import {
  Button,
  Segment
} from 'semantic-ui-react'

import Pagination from '_views/pagination'

const getInvoices = R.compose(
  R.defaultTo([]),
  R.prop('invoices'),
  R.defaultTo({})
)

const Invoices = ({
  institution,
  reseller,
  invoices,
  onTransfer,
  onDeactivate,
  setNavigation
}) => (
  <Segment.Group>
    {invoices.map(invoice => (
      <XeroInvoice
        key={R.prop('line_item_id', invoice)}
        invoice={invoice}
        reseller={reseller}
        institution={institution}
        onTransfer={onTransfer}
        onDeactivate={onDeactivate}
        setNavigation={setNavigation}
      />)
    )}
  </Segment.Group>
)

Invoices.propTypes = {
  invoices: PropTypes.array.isRequired,
  institution: PropTypes.object,
  reseller: PropTypes.object,
  onTransfer: PropTypes.func.isRequired,
  onDeactivate: PropTypes.func.isRequired,
  setNavigation: PropTypes.func.isRequired
}

class XeroInvoices extends React.PureComponent {
  state = {
    pageNum: 1,
    perPage: 10
  }
  goToPage = ({pageNum, perPage, ids}) => {
    this.setState({pageNum, perPage})
  }
  getInvoicesPage = _ => {
    const invoices = getInvoices(this.props.institution || this.props.reseller)
    const p = (this.state.pageNum - 1) * this.state.perPage
    return invoices.slice(p, p + this.state.perPage)
  }

  onRefreshList = (invoice, institution) => {
    this.props.onRefreshList()
  }

  onUpdateXeroInvoices = e => R.path(['reseller', '_id'], this.props)
    ? this.props.onRefresh({resellerId: R.path(['reseller', '_id'], this.props)})
    : R.path(['institution', '_id'], this.props)
      ? this.props.onRefresh({institutionId: R.path(['institution', '_id'], this.props)})
      : null

  render () {
    return (
      <React.Fragment>
        <Button
          size='small'
          onClick={this.onUpdateXeroInvoices}
          style={{marginBottom: '1em'}}
          content='Fetch Invoices'
        />
        <Pagination
          goToPage={this.goToPage}
          pageNum={this.state.pageNum}
          perPage={this.state.perPage}
          total={getInvoices(this.props.institution || this.props.reseller).length}
        />
        <Invoices
          institution={this.props.institution}
          reseller={this.props.reseller}
          invoices={this.getInvoicesPage()}
          onTransfer={this.onRefreshList}
          onDeactivate={this.onRefreshList}
          setNavigation={this.props.setNavigation}
        />
      </React.Fragment>
    )
  }
}
XeroInvoices.propTypes = {
  institution: PropTypes.object,
  reseller: PropTypes.object,
  onRefreshList: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  setNavigation: PropTypes.func.isRequired
}

export default XeroInvoices



// WEBPACK FOOTER //
// ./webAdmin/views/xero/index.js